/* eslint-disable */
// import libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createMuiTheme } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { Space } from 'antd';

// import custom components
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { updateSelectedTab } from 'state/reducers/patient/patientActions';
import { createRoute } from 'routes/patientRouteUtils';
import {
  DatePopover,
  SliderPopover,
  SearchPopover,
} from 'legacy/containers/Popovers';
import CustomTableComponent from '../../components/Common/Table/CustomTableComponent';
import TableHeader from '../../components/Common/Table/TableHeader';
import FormattedDate from '../../components/Common/FormattedDate';
import AvatarNumberAndText from '../../components/Common/Table/CellRendererComponents/Avatar/AvatarNumberAndText';
import SplitLineRowText from '../../components/Common/Table/CellRendererComponents/SplitTextRow/SplitTextRow';
import {RANGE} from '../../constsnts/mdnStableRange'

// constants / utilities
import { PATIENT_FILE_TABS } from '../../pages/PatientFile/PatientFileUtils';
import {
  getDateInDaysHoursMinuit,
  getFormattedDate,
} from '../../components/Common/Table/Utilities/DateUtilities';

// import css
import styles from './KardiaRxCCTPatientResult.css';

const FILTER_TYPES = {
  MDN: 'mdn',
  STABLE: 'stable',
  NAME: 'name',
  ORDERING_PROVIDER: 'orderingProvider',
  STUDY_PERIOD: 'studyPeriod',
  LAST_RECEIVED: 'lastReceived',
  STUDY_START: 'studyStart',
  STUDY_END: 'studyEnd',
};

class KardiaRxCCTPatientResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchPlaceHolderText: null,
      filteredData: [],
      filterApplied: false,
      lastReceivedStartDate: new Date(),
      lastReceivedEndDate: new Date(),
      studyStartFilterStartDate: new Date(),
      studyStartFilterEndDate: new Date(),
      studyEndFilterStartDate: new Date(),
      studyEndFilterEndDate: new Date(),
      filters: {
        mdnFilter: {
          showMdnFilter: false,
          min: RANGE.MIN_VALUE,
          max: RANGE.MAX_VALUE,
          minValue: RANGE.MIN_VALUE,
          maxValue: RANGE.MAX_VALUE,
        },
        stableFilter: {
          showStableFilter: false,
          min: RANGE.MIN_VALUE,
          max: RANGE.MAX_VALUE,
          minValue: RANGE.MIN_VALUE,
          maxValue: RANGE.MAX_VALUE,
        },
        studyPeriodFilter: {
          showStudyFilter: false,
          min: 0,
          max: 30,
          minValue: 0,
          maxValue: 30,
        },
        showNameFilter: false,
        showStudyPeriodFilter: false,
        showLastReceivedFilter: false,
        showOrderingProviderFilter: false,
        showStudyStartFilter: false,
        showStudyEndFilter: false,
      },
    };
  }

  componentDidMount = () => {};

  componentWillReceiveProps = () => {};

  // Row clicked
  clickedRow = (rowData, index) => {
    const { dispatch, history, updatePatientState, updateTab } = this.props;
    updateTab(PATIENT_FILE_TABS.KARDIA_RX);
    history.push(
      createRoute({
        patientId: rowData.participantId,
        kardiaRxEcg: 'patientSearch',
        idtf_connection_id: rowData.id,
      }),
    );
  };

  getTableData = () => {
    if (this.state.filterApplied && this.state.filteredData.length>0) {
      return this.state.filteredData;
    } else {
    const { CCT_PATIENTS_STATE } = this.props;
    const { participants } =
      CCT_PATIENTS_STATE &&
      CCT_PATIENTS_STATE.patients &&
      CCT_PATIENTS_STATE.patients.data[0];
    return participants;
    }
  };

  // Function to get Table data for Slider filter
  getTableDataForSlider = () => {
    const { CCT_PATIENTS_STATE } = this.props;
    const { participants } =
      CCT_PATIENTS_STATE &&
      CCT_PATIENTS_STATE.patients &&
      CCT_PATIENTS_STATE.patients.data[0];
    return participants;
  };

  getTableColumns = () => {
    const { me } = this.props;
    return [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="NAME"
              keyMap="patientFirstName"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.NAME)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <Space direction="vertical">
                    <SearchPopover
                      handleOnChange={e =>
                        this.handleOnChange(e, FILTER_TYPES.NAME)
                      }
                      handleOnOutsidePopoverClick={() =>
                        this.handleOnOutsidePopoverClick()
                      }
                      placeholder="Patient Name..."
                      value={this.state.searchPlaceHolderText}
                    />
                  </Space>
                </Space>
              }
              showFilter={this.state.filters.showNameFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'patientFirstName',
        key: 'patientFirstName',
        width: 150,
        sorter: (a, b) =>
          a.patientFirstName &&
          a.patientFirstName.localeCompare(b.patientFirstName),
        render: (text, record, index) => {
          return (
            <SplitLineRowText
              rowL1Data={`${record.patientLastName} , ${record.patientFirstName}`}
              rowL2Data={record.mrn}
            />
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="MDN COUNT"
              keyMap="totalMdnEcg"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.MDN)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select MDN Range"
                    min={this.state.filters.mdnFilter.min}
                    max={this.state.filters.mdnFilter.max}
                    minValue={this.state.filters.mdnFilter.minValue}
                    maxValue={this.state.filters.mdnFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.MDN)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={this.state.filters.mdnFilter.showMdnFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'totalMdnEcg',
        key: 'totalMdnEcg',
        width: 75,
        sorter: (a, b) => a.totalMdnEcg - b.totalMdnEcg,
        render: (text, record, index) => {
          return (
            <AvatarNumberAndText
              type="number"
              data={text}
              size="medium"
              shape="square"
              color="brick"
            />
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STABLE COUNT"
              keyMap="totalStableEcg"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.STABLE)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select Stable Range"
                    min={this.state.filters.stableFilter.min}
                    max={this.state.filters.stableFilter.max}
                    minValue={this.state.filters.stableFilter.minValue}
                    maxValue={this.state.filters.stableFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.STABLE)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={this.state.filters.stableFilter.showStableFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'totalStableEcg',
        key: 'totalStableEcg',
        width: 75,
        sorter: (a, b) => a.totalStableEcg - b.totalStableEcg,
        render: (text, record, index) => {
          return (
            <AvatarNumberAndText
              type="number"
              data={text}
              size="medium"
              shape="circle"
              color="lightBlue"
            />
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STUDY START DATE/TIME"
              keyMap="studyPeriodStartsAt"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.STUDY_START)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <DatePopover
                    handleOnChange={e =>
                      this.handleOnDateFilterChange(e, FILTER_TYPES.STUDY_START)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    // min={new Date()}
                    // max={new Date()}
                    startDate={this.state.studyStartFilterStartDate}
                    endDate={this.state.studyStartFilterEndDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showStudyStartFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'studyPeriodStartsAt',
        key: 'studyPeriodStartsAt',
        width: 100,
        sorter: (a, b) => {
          const dateA = new Date(a.studyPeriodStartsAt);
          const dateB = new Date(b.studyPeriodStartsAt);
          return dateA - dateB;
        },
        render: (text, record, index) => {
          if (text) {
            return <FormattedDate date={text} />;
          }
          return '-';
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STUDY END DATE"
              keyMap="studyPeriodEndsAt"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.STUDY_END)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <DatePopover
                    handleOnChange={e =>
                      this.handleOnDateFilterChange(
                        e,
                        FILTER_TYPES.STUDY_END,
                      )
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    // min={new Date()}
                    // max={new Date()}
                    startDate={this.state.studyEndFilterStartDate}
                    endDate={this.state.studyEndFilterEndDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showStudyEndFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'studyPeriodEndsAt',
        key: 'studyPeriodEndsAt',
        width: 100,
        sorter: (a, b) => {
          const dateA = new Date(a.studyPeriodEndsAt);
          const dateB = new Date(b.studyPeriodEndsAt);
          return dateA - dateB;
        },
        render: (text, record, index) => {
          if (text) {
            return <FormattedDate date={text} />;
          }
          return '-';
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STUDY DAY"
              keyMap="studyDurationInDays"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.STUDY_PERIOD)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select Day Range"
                    min={this.state.filters.studyPeriodFilter.min}
                    max={this.state.filters.studyPeriodFilter.max}
                    minValue={this.state.filters.studyPeriodFilter.minValue}
                    maxValue={this.state.filters.studyPeriodFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.STUDY_PERIOD)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={
                this.state.filters.studyPeriodFilter.showStudyPeriodFilter
              }
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'studyDurationInDays',
        key: 'studyDurationInDays',
        width: 100,
        sorter: (a, b) => {
          const dateA = new Date(a.studyDurationInDays);
          const dateB = new Date(b.studyDurationInDays);
          return dateA - dateB;
        },
        render: (text, record, index) => {
          if(record.status == ('Complete' || 'Completed')) {
            return <p>Completed</p>;
          }
          if (
            record.studyDurationInDays !== undefined &&
            record.studyDurationInDays !== null
          ) {
            // const dateObj = getDateInDaysHoursMinuit(
            //   record.studyPeriodStartsAt,
            //   null,
            // );
            return <p>Day {record.studyDurationInDays}</p>;
          }
          return '-';
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="LAST RECEIVED"
              keyMap="latestEcgRecordedAt"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.LAST_RECEIVED)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <DatePopover
                    handleOnChange={e => this.handleOnDateFilterChange(e, FILTER_TYPES.LAST_RECEIVED)}
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    // min={new Date()}
                    // max={new Date()}
                    startDate={this.state.lastReceivedStartDate}
                    endDate={this.state.lastReceivedEndDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showLastReceivedFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'latestEcgRecordedAt',
        key: 'latestEcgRecordedAt',
        width: 150,
        sorter: (a, b) => {
          const dateA = new Date(a.latestEcgRecordedAt);
          const dateB = new Date(b.latestEcgRecordedAt);
          return dateA - dateB;
        },
        render: (text, record, index) => {
          if (text !== undefined && text !== null) {
            const dateObj = getDateInDaysHoursMinuit(null, text);
            const dateFormatted = getFormattedDate(text, me);
            return (
              <p>
                {dateObj.days} {dateObj.days >1 ? "days," : "day,"} {dateObj.hours} hrs ago
                {'\n'}
                {dateFormatted}
              </p>
            );
          }
          return '-';
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="PROVIDER"
              keyMap="orderingProviderFirstName"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ORDERING_PROVIDER)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ORDERING_PROVIDER)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Ordering Provider Name..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showOrderingProviderFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'orderingProviderFirstName',
        key: 'orderingProviderFirstName',
        width: 200,
        sorter: (a, b) =>
          a.orderingProviderFirstName &&
          a.orderingProviderFirstName.localeCompare(
            b.orderingProviderFirstName,
          ),
        render: (text, record, index) => {
          return (
            <SplitLineRowText
              rowL1Data={`${record.orderingProviderFirstName} ${record.orderingProviderLastName}`}
              rowL2Data={record.orderingProviderTeamName}
            />
          );
        },
      },
    ];
  };

  handleOnOutsidePopoverClick = () => {
    this.setState({
      ...this.state,
      filters: {
        mdnFilter: { ...this.state.filters.mdnFilter, showMdnFilter: false },
        stableFilter: {
          ...this.state.filters.stableFilter,
          showStableFilter: false,
        },
        showNameFilter: false,
        studyPeriodFilter: {
          ...this.state.filters.studyPeriodFilter,
          showStudyPeriodFilter: false,
        },
        showOrderingProviderFilter: false,
        showLastReceivedFilter: false,
        showStudyStartFilter: false,
        showStudyEndFilter: false,
      },
    });
  };

  filterChange = filterType => {
    let filterValue = this.state.filters;
    switch (filterType) {
      case FILTER_TYPES.MDN:
        filterValue.mdnFilter.showMdnFilter = true;
        break;
      case FILTER_TYPES.STABLE:
        filterValue.stableFilter.showStableFilter = true;
        break;
      case FILTER_TYPES.NAME:
        filterValue.showNameFilter = true;
        break;
      case FILTER_TYPES.STUDY_PERIOD:
        filterValue.studyPeriodFilter.showStudyPeriodFilter = true;
        break;
      case FILTER_TYPES.LAST_RECEIVED:
        filterValue.showLastReceivedFilter = true;
        break;
      case FILTER_TYPES.ORDERING_PROVIDER:
        filterValue.showOrderingProviderFilter = true;
        break;
      case FILTER_TYPES.STUDY_START:
        filterValue.showStudyStartFilter = true;
        break;
      case FILTER_TYPES.STUDY_END:
        filterValue.showStudyEndFilter = true;
        break;
      default:
        break;
    }
    this.setState({
      ...this.state,
      filters: {
        ...filterValue,
      },
    });
  };

  handleOnDateFilterChange = (e, filterType) => {
    let filteredEvents = [];

    switch (filterType) {
      case FILTER_TYPES.LAST_RECEIVED:
        this.setState({
          lastReceivedStartDate: e.startDate,
          lastReceivedEndDate: e.endDate,
        });
        filteredEvents = this.getTableData().filter(item => {
          return (
            new Date(item.latestEcgRecordedAt) >= e.startDate &&
            new Date(item.latestEcgRecordedAt) <= e.endDate
          );
        });
        break;
      case FILTER_TYPES.STUDY_START:
        this.setState({
          studyStartFilterStartDate: e.startDate,
          studyStartFilterEndDate: e.endDate,
        });
        filteredEvents = this.getTableData().filter(item => {
          return (
            new Date(item.studyPeriodStartsAt) >= e.startDate &&
            new Date(item.studyPeriodStartsAt) <= e.endDate
          );
        });
        break;
      case FILTER_TYPES.STUDY_END:
        this.setState({
          studyEndFilterStartDate: e.startDate,
          studyEndFilterEndDate: e.endDate,
        });
        filteredEvents = this.getTableData().filter(item => {
          return (
            new Date(item.studyPeriodEndsAt) >= e.startDate &&
            new Date(item.studyPeriodEndsAt) <= e.endDate
          );
        });
        break;
      default:
        break;
    }
    this.setState({filterApplied: true, filteredData: filteredEvents });
  };

  handleOnChange = (e, filterType) => {
    let filteredEvents = [];
    const searchText = e.toLowerCase();
    if (searchText == '') {
      this.setState({ ...this.state, filterApplied: false, searchPlaceHolderText: searchText });
    } else {
    switch (filterType) {
      case FILTER_TYPES.NAME:
        filteredEvents = this.getTableData().filter(item => {
          let name = `${item.patientLastName} , ${item.patientFirstName}`;
          name = name.toLowerCase();
          return name.includes(searchText);
        });
        break;
      case FILTER_TYPES.ORDERING_PROVIDER:
        filteredEvents = this.getTableData().filter(item => {
          let name = `${item.orderingProviderFirstName} , ${item.orderingProviderFirstName}`;
          name = name.toLowerCase();
          return name.includes(searchText);
        });
        break;
      default:
        break;
    }
    // console.log('filteredEvents', filteredEvents);
    this.setState({...this.state, filterApplied: true, filteredData: filteredEvents, searchPlaceHolderText: searchText });
  }
  };

  handleOnSliderChange = (e, filterType) => {
    let filteredEvents = [];
    switch (filterType) {
      case FILTER_TYPES.MDN:
        this.setState({
          filters: {
            ...this.state.filters,
            mdnFilter: {
              ...this.state.filters.mdnFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableDataForSlider().filter(item => {
          return item.totalMdnEcg >= e[0] && item.totalMdnEcg <= e[1];
        });
        break;
      case FILTER_TYPES.STABLE:
        this.setState({
          filters: {
            ...this.state.filters,
            stableFilter: {
              ...this.state.filters.stableFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableDataForSlider().filter(item => {
          return item.totalStableEcg >= e[0] && item.totalStableEcg <= e[1];
        });
        break;
      case FILTER_TYPES.STUDY_PERIOD:
        this.setState({
          filters: {
            ...this.state.filters,
            studyPeriodFilter: {
              ...this.state.filters.studyPeriodFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableDataForSlider().filter(item => {
          return item.studyDurationInDays >= e[0] && item.studyDurationInDays <= e[1];
        });
        break;
      default:
        break;
    }
    this.setState({ filterApplied: true, filteredData: filteredEvents });
  };

  render() {
    const { me, CCT_PATIENTS_STATE } = this.props;
    return (
      <React.Fragment>
        <CustomTableComponent
          columns={this.getTableColumns()}
          data={
            this.state.filterApplied && this.state.filteredData
              ? this.state.filteredData
              : CCT_PATIENTS_STATE &&
                CCT_PATIENTS_STATE.patients &&
                CCT_PATIENTS_STATE.patients.data[0] &&
                CCT_PATIENTS_STATE.patients.data[0].participants
          }
          scrollHeight={{ y:  'calc(100vh - 35em)'}}
          clickedRow={this.clickedRow}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const CCT_PATIENTS_STATE = state.kardiaRx.kardiaRxCCTPatients;

  return {
    me,
    CCT_PATIENTS_STATE,
  };
};

const mapActionCreators = {
  updateTab: updateSelectedTab,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxCCTPatientResult));



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTPatientResult/KardiaRxCCTPatientResult.jsx